import { css } from '@emotion/react';

const FONT = `'Neue Haas Grotesk Display Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

export const cotizacionesCSS = () => css`
    font-family: ${FONT};
    color: #0f172a;
    width: 90%;
    margin: 0 auto;

    .cot-hero {
        position: relative;
        border-radius: 18px;
        padding: 1.1rem 1.4rem 1.2rem;
        background: linear-gradient(120deg, #204B7B 0%, #32B8DF 60%, #00BA6E 100%);
        color: #ffffff;
        overflow: hidden;
        margin-bottom: 1rem;
    }
    .cot-hero::after {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(circle at 90% 20%, rgba(255,255,255,0.18), transparent 60%);
        pointer-events: none;
    }

    .cot-hero-title {
        font-size: 1.05rem;
        font-weight: 700;
        margin: 0 0 0.2rem;
        letter-spacing: 0.02em;
    }
    .cot-hero-sub {
        font-size: 0.78rem;
        margin: 0 0 0.95rem;
        opacity: 0.85;
    }

    .cot-topbar {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        margin-bottom: 0.85rem;
        flex-wrap: wrap;
    }
    .cot-topbar > [css] {
        flex-shrink: 0;
    }
    .cot-toolbar {
        display: flex;
        gap: 0.6rem;
        align-items: center;
        margin-bottom: 0.85rem;
        flex-wrap: wrap;
    }
    .cot-search {
        flex: 1;
        min-width: 200px;
        max-width: 100%;
        position: relative;
    }
    .cot-search .cot-search-icon {
        position: absolute;
        right: 1.1rem;
        top: 50%;
        transform: translateY(-50%);
        color: #94a3b8;
        font-size: 0.85rem;
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .cot-search input {
        width: 100%;
        padding: 0.55rem 2.2rem 0.55rem 1rem;
        border-radius: 999px;
        border: 1px solid #e2e8f0;
        background: #ffffff;
        color: #0f172a;
        font-size: 0.85rem;
        font-family: ${FONT};
        outline: none;
        transition: border-color 0.18s, box-shadow 0.18s;
    }
    .cot-search input:focus {
        border-color: #34C6F1;
        box-shadow: 0 0 0 3px rgba(52, 198, 241, 0.18);
    }

    .cot-list {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;

        @media (min-width: 769px) {
            gap: 4px;
        }
    }

    .cot-list-card {
        border-radius: 12px;
        border: 1px solid #EEF1F4;
        background: #fff;
        overflow: hidden;

        .cr-desktop-grid {
            border-top: 0;
        }
    }

    .cot-eyebrow {
        display: flex;
        align-items: center;
        gap: 12px;
        margin: 4px 0 12px;
    }
    .cot-eyebrow-title {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.10em;
        text-transform: uppercase;
        background: var(--pei-gradient-tri);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .cot-eyebrow-slashes {
        color: #CBD5E1;
        font-weight: 300;
        font-size: 16px;
        letter-spacing: 0.4em;
    }
    .cot-eyebrow-rule {
        flex: 1;
        height: 1px;
        background: linear-gradient(to right, #EEF1F4 0%, transparent 100%);
    }
    .cot-eyebrow-count {
        font-size: 11px;
        color: #94A3B8;
        font-weight: 500;
    }

    .cot-hairline-tri {
        height: 2px;
        width: 100%;
        background: var(--pei-gradient-tri);
        border-radius: 2px;
    }

    .cot-row-header {
        display: grid;
        grid-template-columns: 1.2fr 1.05fr 1.15fr 110px 290px;
        gap: 20px;
        padding: 14px 20px 10px;

        .cot-row-header-cell {
            font-size: 10px;
            font-weight: 600;
            letter-spacing: 0.08em;
            color: #94A3B8;
            text-transform: uppercase;
        }
        .cot-row-header-cell.align-right { text-align: right; }
        .cot-row-header-cell.align-center { text-align: center; }
    }
    @media (max-width: 768px) {
        .cot-row-header { display: none; }
    }

    .cot-empty {
        background: #ffffff;
        border-radius: 14px;
        border: 1px dashed #e2e8f0;
        padding: 3rem 1rem;
        text-align: center;
        color: #94a3b8;
        font-size: 0.88rem;
    }
    .cot-empty i {
        display: block;
        font-size: 1.6rem;
        margin-bottom: 0.5rem;
        opacity: 0.55;
    }

    .cot-loading {
        background: #ffffff;
        border-radius: 14px;
        padding: 2rem 1rem;
        text-align: center;
        color: #64748b;
        font-size: 0.85rem;
    }

    .cot-pagination {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1rem;
        font-size: 0.78rem;
        color: #64748b;
    }
    .cot-pagination button {
        font-family: ${FONT};
        background: #ffffff;
        border: 1px solid #e2e8f0;
        color: #475569;
        padding: 0.35rem 0.85rem;
        border-radius: 999px;
        font-size: 0.78rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.15s;
    }
    .cot-pagination button:hover:not(:disabled) {
        border-color: #34C6F1;
        color: #0f172a;
    }
    .cot-pagination button:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
`;

/* ─── KPI CHIPS ──────────────────────────────────────────────── */

const TONE = {
    all:       { accent: '#204B7B', soft: '#eef2f7', text: '#1e293b' },
    progress:  { accent: '#34C6F1', soft: '#e3f5fb', text: '#1A7C9C' },
    approved:  { accent: '#00BA6E', soft: '#e6f9f1', text: '#007A4D' },
    rejected:  { accent: '#ef4444', soft: '#fdeaea', text: '#B91C1C' },
    docs:      { accent: '#f5c842', soft: '#fef9e6', text: '#A87D00' },
    cancelled: { accent: '#94a3b8', soft: '#f1f5f9', text: '#475569' },
    analysis:  { accent: '#8b5cf6', soft: '#f3eefe', text: '#6d28d9' },
    ocular:    { accent: '#0ea5e9', soft: '#e0f2fe', text: '#0369a1' },
    quoting:   { accent: '#10b981', soft: '#dcfce7', text: '#047857' },
    paid:      { accent: '#22c55e', soft: '#dcfce7', text: '#15803d' },
    invoiced:  { accent: '#f97316', soft: '#ffedd5', text: '#c2410c' },
    contract:  { accent: '#059669', soft: '#ecfdf5', text: '#065f46' },
};

export const kpiChipsCSS = () => css`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 0.7rem;
    margin: 0 0 1rem;

    /* Total: columna izquierda, ocupa las 2 filas */
    .kpi-chip.kpi-all {
        grid-row: span 2;
        grid-column: 1;
    }

    @media (max-width: 1050px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        /* Tablet: 3×3 sin spanning */
        .kpi-chip.kpi-all {
            grid-row: span 1;
            grid-column: span 1;
        }
    }

    /* ─── MOBILE: scroll horizontal fluido con snap ─────────────── */
    @media (max-width: 768px) {
        display: flex;
        grid-template-columns: none;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        scroll-padding: 0 1rem;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        gap: 0.55rem;
        padding: 0.25rem 1rem 0.85rem;
        margin: 0 -1rem 0.6rem;
        /* Fade en los bordes para sugerir más contenido */
        mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        -webkit-mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        /* Hide scrollbar */
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }
    }

    /* Total: alto, contenido centrado verticalmente */
    .kpi-chip.kpi-all {
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 0.5rem;
    }
    .kpi-chip.kpi-all .kpi-icon {
        width: 44px;
        height: 44px;
        font-size: 1.15rem;
    }
    .kpi-chip.kpi-all .kpi-value {
        font-size: 2rem;
    }

    @media (max-width: 1050px) {
        .kpi-chip.kpi-all {
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
        }
        .kpi-chip.kpi-all .kpi-icon { width: 36px; height: 36px; font-size: 1rem; }
        .kpi-chip.kpi-all .kpi-value { font-size: 1.5rem; }
    }

    .kpi-chip {
        position: relative;
        display: flex;
        align-items: center;
        gap: 0.7rem;
        background: #ffffff;
        border: 1px solid #e2e8f0;
        border-radius: 14px;
        padding: 0.85rem 0.9rem;
        cursor: pointer;
        transition:
            transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1),
            border-color 0.18s,
            box-shadow 0.22s ease,
            background 0.22s ease;
        text-align: left;
        font-family: ${FONT};
        color: #0f172a;
        overflow: hidden;
        box-shadow: 2px 2px 11px rgba(33, 88, 140, 0.04);
        will-change: transform;
        animation: kpi-fade-in 0.45s ease both;
    }
    @keyframes kpi-fade-in {
        from { opacity: 0; transform: translateY(8px); }
        to   { opacity: 1; transform: translateY(0); }
    }
    .kpi-chip:active {
        transform: scale(0.97);
        transition: transform 0.08s ease;
    }
    .kpi-chip:hover {
        transform: translateY(-2px);
        box-shadow: 
            inset 3px 0 0 transparent,
            0 8px 18px rgba(33, 88, 140, 0.08);
    }

    /* Tones */
    ${Object.entries(TONE).map(([key, t]) => `
        .kpi-chip.kpi-${key}:hover { 
            border-color: ${t.accent}; 
            box-shadow: inset 3px 0 0 ${t.accent}, 0 8px 18px rgba(33, 88, 140, 0.08);
        }
        .kpi-chip.kpi-${key}.active {
            border-color: ${t.accent};
            background: ${t.soft};
            box-shadow: inset 3px 0 0 ${t.accent}, 0 6px 16px ${t.accent}26;
        }
        .kpi-chip.kpi-${key} .kpi-icon { color: ${t.accent}; background: ${t.soft}; }
        .kpi-chip.kpi-${key} .kpi-bar-fill { background: ${t.accent}; }
        .kpi-chip.kpi-${key}.active .kpi-icon { background: #ffffff; }
    `).join('\n')}

    .kpi-icon {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
    }

    .kpi-body {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        gap: 2px;
    }
    .kpi-label {
        font-size: 0.62rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.07em;
        color: #64748b;
        line-height: 1.1;
    }
    .kpi-value {
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        letter-spacing: -0.015em;
        color: #0f172a;
        margin-top: 2px;
    }
    .kpi-page-line {
        display: flex;
        align-items: baseline;
        gap: 4px;
        margin-top: 3px;
        font-size: 0.66rem;
        line-height: 1.1;
        color: #64748b;
        font-weight: 500;
    }
    .kpi-page-num {
        font-weight: 700;
        color: #0f172a;
    }

    .kpi-bar {
        display: block;
        height: 3px;
        background: #f1f5f9;
        border-radius: 999px;
        overflow: hidden;
        margin-top: 6px;
    }
    .kpi-bar-fill {
        display: block;
        height: 100%;
        border-radius: 999px;
        transition: width 0.4s ease;
    }

    @media (max-width: 768px) {
        .kpi-chip {
            flex: 0 0 auto;
            min-width: 148px;
            max-width: 168px;
            scroll-snap-align: start;
            scroll-snap-stop: always;
            padding: 0.7rem 0.75rem;
            gap: 0.55rem;
        }
        .kpi-icon { width: 32px; height: 32px; font-size: 0.9rem; }
        .kpi-value { font-size: 1.35rem; }
        .kpi-label { font-size: 0.6rem; }
        .kpi-page-line { font-size: 0.62rem; }
        /* Hover en touch: usa active pulse en su lugar */
        .kpi-chip:hover { transform: none; box-shadow: 2px 2px 11px rgba(33, 88, 140, 0.04); }
        .kpi-chip.active {
            transform: scale(1.02);
            transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
    }
`;

/* ─── STATUS FILTER BAR ──────────────────────────────────────── */

export const statusFilterBarCSS = () => css`
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-bottom: 0.85rem;

    .sf-btn {
        font-family: ${FONT};
        padding: 6px 16px;
        border-radius: 20px;
        border: 1px solid #e2e8f0;
        background: #fff;
        color: #475569;
        font-size: 0.8rem;
        font-weight: 500;
        cursor: pointer;
        transition:
            background 0.18s ease,
            border-color 0.18s ease,
            color 0.18s ease,
            transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
        white-space: nowrap;
    }
    .sf-btn:hover { background: #f8fafc; border-color: #cbd5e1; }
    .sf-btn:active { transform: scale(0.95); }
    .sf-btn.active {
        background: #32B8DF;
        color: #ffffff;
        border-color: #32B8DF;
        transform: scale(1.04);
    }

    @media (max-width: 768px) {
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x proximity;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        padding: 0.2rem 1rem 0.5rem;
        margin: 0 -1rem 0.6rem;
        gap: 0.45rem;
        mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        -webkit-mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }

        .sf-btn {
            flex: 0 0 auto;
            scroll-snap-align: start;
        }
    }
`;

/* ─── COTIZACION ROW ─────────────────────────────────────────── */

const STATUS_PILL = {
    approved:     { bg: '#e8fbf1', fg: '#00BA6E' },
    contract:     { bg: '#e8fbf1', fg: '#00BA6E' },
    in_progress:  { bg: '#e1f5fb', fg: '#1f8aa7' },
    docs_pending: { bg: '#fef6dc', fg: '#a47700' },
    rejected:     { bg: '#fee2e2', fg: '#b91c1c' },
    cancelled:    { bg: '#f1f5f9', fg: '#64748b' },
    analysis:     { bg: '#f3eefe', fg: '#6d28d9' },
    ocular:       { bg: '#e0f2fe', fg: '#0369a1' },
    quoting:      { bg: '#dcfce7', fg: '#047857' },
    paid:         { bg: '#dcfce7', fg: '#15803d' },
    invoiced:     { bg: '#ffedd5', fg: '#c2410c' },
};

export const cotizacionRowCSS = (statusCode, isExpanded) => {
    const pill = STATUS_PILL[statusCode] ?? STATUS_PILL.in_progress;

    return css`
        position: relative;
        background: #ffffff;
        font-family: ${FONT};
        cursor: pointer;

        /* Desktop: flat row with border-top + soft hover bg */
        @media (min-width: 769px) {
            transition: background 0.15s ease;
            &:hover { background: #FAFBFC; }
        }

        /* Mobile: card with status accent + shadow (legacy look preserved) */
        @media (max-width: 768px) {
            border-radius: 14px;
            border: 1px solid ${isExpanded ? pill.fg : '#e2e8f0'};
            box-shadow:
                inset 3px 0 0 ${pill.fg},
                0 1px 6px rgba(0, 0, 0, 0.06);
            overflow: hidden;
            transition: all 0.22s ease;
            margin-bottom: 0.2rem;

            &:hover {
                border-color: ${isExpanded ? pill.fg : '#cbd5e1'};
                box-shadow:
                    inset 3px 0 0 ${pill.fg},
                    0 4px 14px rgba(0, 0, 0, 0.08);
            }
        }

        /* ── COLLAPSED HEADER ────────────────────────────────── */
        .cr-header {
            display: flex;
            align-items: center;
            padding: 0.75rem 0.9rem;
            cursor: pointer;
            gap: 0.8rem;
        }

        .cr-info {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 2px;
        }
        .cr-info-top {
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        .cr-name {
            font-size: 0.95rem;
            font-weight: 700;
            color: #0f172a;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .cr-meta {
            font-size: 0.72rem;
            color: #64748b;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .cr-car-summary {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 2px;
            text-align: right;
        }
        .cr-car-unit {
            font-size: 0.78rem;
            font-weight: 600;
            color: #475569;
        }
        .cr-price-value {
            font-size: 0.9rem;
            font-weight: 800;
            color: #0f172a;
        }

        .cr-toggle-icon {
            color: #94a3b8;
            font-size: 0.8rem;
            transition: transform 0.2s;
        }

        /* ── EXPANDED CONTENT ────────────────────────────────── */
        .cr-expanded-content {
            overflow: hidden;
            border-top: 1px solid #f1f5f9;
            background: #fafbfc;
        }

        .cr-details-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 0.8rem;
            padding: 1.1rem 1rem 0.8rem;
        }
        .cr-detail-item {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }
        .cr-detail-label {
            font-size: 0.6rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: #94a3b8;
        }
        .cr-detail-value {
            font-size: 0.82rem;
            font-weight: 600;
            color: #334155;
            display: flex;
            align-items: center;
            gap: 5px;
            i { font-size: 0.65rem; color: #cbd5e1; }
            small { font-size: 0.6rem; color: #94a3b8; margin-left: 1px; }
        }
        .cr-advisor-value {
            color: #0f172a;
        }
        .cr-me {
            color: #32B8DF;
            font-weight: 700;
        }
        .cr-unassigned {
            color: #94a3b8;
            font-style: italic;
            font-weight: 400;
        }

        .cr-action-box {
            margin: 0.4rem 1rem 1rem;
            padding: 0.75rem 0.9rem;
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 12px;
            display: flex;
            flex-direction: column;
            gap: 4px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        }
        .cr-action-box.has-requote {
            background: #fff7ed;
            border-color: #fdba74;
        }
        .cr-action-main {
            font-size: 0.8rem;
            font-weight: 700;
            color: ${pill.fg};
        }
        .cr-action-detail {
            font-size: 0.7rem;
            color: #64748b;
            line-height: 1.4;
        }

        .cr-action-clickable {
            cursor: pointer;
        }

        .cr-detail-more {
            background: none;
            border: none;
            padding: 0 0 0 4px;
            font-size: 0.7rem;
            color: #1565C0;
            cursor: pointer;
            font-weight: 600;
            line-height: 1.4;
        }
        .cr-detail-more:hover {
            color: #0d47a1;
        }

        .cr-actions-footer {
            padding: 0.9rem 1rem;
            border-top: 1px solid #f1f5f9;
            background: #ffffff;
            display: flex;
            justify-content: flex-end;
            gap: 0.5rem;
        }

        .cr-advisor-chip {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            margin-top: 0;
            padding: 3px 10px;
            background: rgba(50, 184, 223, 0.12);
            border: 1px solid rgba(50, 184, 223, 0.32);
            border-radius: 999px;
            color: #0E7490;
            font-size: 0.72rem;
            font-weight: 700;
            width: fit-content;
            transition: all 0.2s;
            i { color: #0E7490; }
        }
        .cr-advisor-chip:hover {
            background: rgba(50, 184, 223, 0.18);
            color: #0E7490;
        }
        .cr-mobile-stepper {
            padding: 0.8rem 1rem 1.1rem;
            background: #ffffff;
            border-top: 1px solid #f8fafc;
            display: block;
        }
        @media (min-width: 769px) {
            .cr-mobile-stepper { display: none !important; }
        }

        /* ── DESKTOP GRID VIEW (flat, calm) ──────────────────── */
        .cr-desktop-grid {
            display: grid;
            grid-template-columns: 1.2fr 1.05fr 1.15fr 110px 290px;
            gap: 20px;
            align-items: center;
            padding: 18px 20px;
            border-top: 1px solid #F1F5F9;
            width: 100%;
            min-width: 0;
        }

        /* Col 1 — Client */
        .cr-desktop-grid .cr-info {
            padding: 0;
            border: none;
            min-height: 0;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0;
        }
        .cr-desktop-grid .cr-info-top {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: 0;
        }
        .cr-desktop-grid .cr-name {
            font-size: 14px;
            font-weight: 600;
            color: #0F172A;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
        }
        .cr-desktop-grid .cr-meta {
            font-size: 12px;
            color: #94A3B8;
            margin-top: 2px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .cr-desktop-grid .cr-persona-mini {
            font-size: 9px;
            font-weight: 600;
            letter-spacing: 0.04em;
            padding: 2px 5px;
            border-radius: 4px;
            line-height: 1.3;
            white-space: nowrap;
            box-shadow: none;
            background: #F1F5F9;
            color: #475569;
        }
        .cr-desktop-grid .cr-persona-mini.cr-persona-mini-pf   { background: #F1F5F9; color: #475569; }
        .cr-desktop-grid .cr-persona-mini.cr-persona-mini-pm   { background: #EAF1F8; color: #214B7B; }
        .cr-desktop-grid .cr-persona-mini.cr-persona-mini-pfae { background: #FBEEE0; color: #7A3A0C; }
        .cr-desktop-grid .cr-source-chip.cr-source-trim {
            font-size: 9px;
            font-weight: 600;
            letter-spacing: 0.04em;
            padding: 2px 5px;
            border-radius: 4px;
            background: #0C2036;
            color: #ffffff;
            border: none;
            text-transform: uppercase;
            i { display: none; }
        }
        .cr-desktop-grid .cr-advisor-chip {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            margin-top: 4px;
            padding: 2px 8px;
            background: rgba(50, 184, 223, 0.12);
            border: 1px solid rgba(50, 184, 223, 0.32);
            border-radius: 999px;
            color: #0E7490;
            font-size: 11px;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            width: fit-content;
            i { color: #0E7490; font-size: 10px; }
            &:hover {
                background: rgba(50, 184, 223, 0.18);
                color: #0E7490;
            }
        }

        /* Col 2 — Unit + finance */
        .cr-desktop-grid .cr-car-col {
            padding: 0;
            border: none;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0;
        }
        .cr-desktop-grid .cr-car-unit {
            font-size: 13.5px;
            font-weight: 500;
            color: #0F172A;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .cr-desktop-grid .cr-car-finance {
            font-size: 12px;
            color: #64748B;
            margin-top: 2px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .cr-desktop-grid .cr-car-permes { color: #94A3B8; }
        .cr-desktop-grid .cr-car-sep    { color: #CBD5E1; }

        /* Col 3 — Action */
        .cr-desktop-grid .cr-action {
            padding: 0;
            border: none;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0;
            background: transparent;
        }
        .cr-desktop-grid .cr-action.has-requote { background: transparent; }
        .cr-desktop-grid .cr-action-line1 {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            min-width: 0;
        }
        .cr-desktop-grid .cr-action-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            flex-shrink: 0;
        }
        .cr-desktop-grid .cr-action-text {
            font-size: 12.5px;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
        }
        .cr-desktop-grid .cr-action-detail {
            display: block;
            font-size: 12px;
            color: #94A3B8;
            margin-top: 2px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.35;
        }
        .cr-desktop-grid .cr-detail-more {
            padding-left: 4px;
            font-size: 12px;
            color: #1565C0;
            font-weight: 600;
            cursor: pointer;
        }
        .cr-desktop-grid .cr-detail-more:hover { color: #0d47a1; }

        /* Col 4 — Price + date (plain, no chip) */
        .cr-desktop-grid .cr-price {
            padding: 0;
            border: none;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;
            gap: 0;
            text-align: right;
        }
        .cr-desktop-grid .cr-price-value {
            font-size: 14px;
            font-weight: 600;
            color: #0F172A;
            white-space: nowrap;
        }
        .cr-desktop-grid .cr-price-date {
            display: inline;
            font-size: 11.5px;
            color: #94A3B8;
            font-weight: 400;
            background: transparent;
            border: none;
            border-radius: 0;
            padding: 0;
            margin-top: 2px;
            white-space: nowrap;
            i { display: none; }
        }

        /* Col 5 — Stepper */
        .cr-desktop-grid .cr-stepper {
            padding: 0;
            border: none;
            min-width: 0;
            display: flex;
            align-items: center;
        }

        .cr-overlay-actions {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            z-index: 10;
            display: flex;
            align-items: center;
            gap: 0.4rem;
            padding: 5px 6px;
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.92);
            backdrop-filter: blur(12px) saturate(1.6);
            border: 1px solid rgba(226, 232, 240, 0.7);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.10);
        }

        /* ── RESPONSIVE SWITCH ──────────────────────────────── */
        @media (min-width: 769px) {
            .cr-header, .cr-expanded-content { display: none !important; }
        }
        @media (max-width: 768px) {
            .cr-desktop-grid { display: none !important; }
        }

        /* ── SOURCE CHIPS (reused) ─────────────────────────── */
        .cr-source-chip {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            font-size: 0.6rem;
            font-weight: 800;
            letter-spacing: 0.08em;
            padding: 3px 8px;
            border-radius: 999px;
            white-space: nowrap;
            text-transform: uppercase;
        }
        .cr-source-chip.cr-source-trim {
            background: linear-gradient(135deg, #fde68a 0%, #fbbf24 100%);
            color: #78350f;
            border: 1px solid #f59e0b;
        }
        /* ── PERSONA MINI (minimalista) ───────────────── */
        .cr-persona-mini {
            display: inline-flex;
            align-items: center;
            font-size: 0.58rem;
            font-weight: 700;
            letter-spacing: 0.05em;
            padding: 1px 5px;
            border-radius: 4px;
            background: transparent;
            line-height: 1.3;
            white-space: nowrap;
        }
        .cr-persona-mini.cr-persona-mini-pf   { color: #2563eb; box-shadow: inset 0 0 0 1px #bfdbfe; }
        .cr-persona-mini.cr-persona-mini-pfae { color: #7c3aed; box-shadow: inset 0 0 0 1px #ddd6fe; }
        .cr-persona-mini.cr-persona-mini-pm   { color: #15803d; box-shadow: inset 0 0 0 1px #bbf7d0; }

        .cr-requote-chip {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            font-size: 0.6rem;
            font-weight: 800;
            padding: 2px 7px;
            border-radius: 5px;
            background: #fff7ed;
            color: #c2410c;
            border: 1px solid #fdba74;
            width: fit-content;
            margin-top: 1px;
            animation: cr-requote-pulse 2s ease-in-out infinite;
        }

        /* ─── Copy-to-clipboard helper (icono a la izquierda, sutil) ─── */
        .cr-copyable {
            display: inline-flex;
            align-items: center;
            gap: 3px;
            min-width: 0;
            vertical-align: middle;
        }
        .cr-copyable .cr-copyable-text {
            display: inline-flex;
            align-items: center;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .cr-copy-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 14px;
            height: 14px;
            padding: 0;
            border: none;
            border-radius: 3px;
            background: transparent;
            color: #94a3b8;
            cursor: pointer;
            transition: color 0.15s, transform 0.1s;
            flex-shrink: 0;
        }
        .cr-copy-btn i {
            font-size: 0.6rem;
            line-height: 1;
        }
        .cr-copy-btn:hover {
            color: #0E7490;
        }
        .cr-copy-btn:active {
            transform: scale(0.9);
        }
        .cr-copy-btn:disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }
        .cr-copy-btn.is-copied {
            color: #15803d;
        }

        /* Separación entre email e ID en la misma línea meta */
        .cr-meta {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
        }
        .cr-meta.cr-meta-phone {
            color: #475569;
        }
        .cr-meta .cr-meta-uid {
            color: #94a3b8;
            font-variant-numeric: tabular-nums;
        }
    `;
};

/* ─── STEPPER FUNNEL ─────────────────────────────────────────── */

const STEP_COLOR = {
    done:    '#00BA6E',
    active:  '#32B8DF',
    pending: '#cbd5e1',
    rej:     '#ef4444',
    warn:    '#f59e0b',
    na:      '#e2e8f0',
};

export const stepperFunnelCSS = () => css`
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    font-family: ${FONT};
    width: 100%;
    min-width: 0;

    @keyframes sf-pulse {
        0%   { box-shadow: 0 0 0 0 rgba(50, 184, 223, 0.45); }
        70%  { box-shadow: 0 0 0 7px rgba(50, 184, 223, 0); }
        100% { box-shadow: 0 0 0 0 rgba(50, 184, 223, 0); }
    }

    /* ── Track: Horizontal Scroll with Touch Support ────────── */
    .sf-track {
        display: flex;
        align-items: flex-start;
        gap: 0;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        padding: 0.8rem 0.5rem 1.2rem;
        width: 100%;
        min-width: 0;
        position: relative; /* CRITICAL for offsetLeft calculation */
        
        /* Hide Scrollbar */
        scrollbar-width: none; 
        &::-webkit-scrollbar { display: none; }

        /* Mask for fade effect on edges */
        mask-image: linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%);
    }

    .sf-slot {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.6rem;
        flex: 0 0 90px; /* Fixed width, no squashing */
        scroll-snap-align: center;
        position: relative;
        z-index: 2;
    }

    /* ── Dot ───────────────────────────────────────────────────── */
    .sf-dot {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: #ffffff;
        border: 2px solid #e2e8f0;
        color: #94a3b8;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        transition: transform 0.18s, background 0.2s, border-color 0.2s;
        z-index: 2;
    }
    .sf-dot i, .sf-dot .sf-glyph-num, .sf-dot .sf-glyph-dash {
        font-size: 0.7rem;
        font-weight: 700;
        line-height: 1;
    }

    .sf-dot.done {
        background: ${STEP_COLOR.done};
        border-color: ${STEP_COLOR.done};
        color: #ffffff;
        box-shadow: 0 1px 4px rgba(0, 186, 110, 0.2);
    }
    .sf-dot.active {
        background: ${STEP_COLOR.active};
        border-color: ${STEP_COLOR.active};
        color: #ffffff;
        animation: sf-pulse 1.6s infinite;
    }
    .sf-dot.pending {
        background: #ffffff;
        border-color: #cbd5e1;
    }
    .sf-dot.rej {
        background: ${STEP_COLOR.rej};
        border-color: ${STEP_COLOR.rej};
        color: #ffffff;
    }
    .sf-dot.warn {
        background: ${STEP_COLOR.warn};
        border-color: ${STEP_COLOR.warn};
        color: #ffffff;
        box-shadow: 0 1px 4px rgba(245, 158, 11, 0.25);
    }
    .sf-dot.na {
        background: #f8fafc;
        border-color: #e2e8f0;
        border-style: dashed;
        color: #cbd5e1;
    }

    /* ── Label ─────────────────────────────────────────────────── */
    .sf-label {
        font-size: 0.65rem;
        color: #64748b;
        text-align: center;
        width: 100%;
        line-height: 1.25;
        font-weight: 500;
        white-space: normal;
        padding: 0 4px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
    }
    .sf-label.done   { color: ${STEP_COLOR.done}; font-weight: 600; }
    .sf-label.active { color: ${STEP_COLOR.active}; font-weight: 700; }
    .sf-label.rej    { color: ${STEP_COLOR.rej}; font-weight: 600; }
    .sf-label.warn   { color: ${STEP_COLOR.warn}; font-weight: 600; }

    /* ── Connector Line ────────────────────────────────────────── */
    .sf-line {
        flex: 0 0 40px; /* Fixed spacing between dots */
        height: 2px;
        margin-top: 13px;
        background: #e2e8f0;
        border-radius: 999px;
        position: relative;
        z-index: 1;
        /* No negative margins to avoid squashing text */
    }
    .sf-line.done {
        background: ${STEP_COLOR.done};
    }
    .sf-line.done-active {
        background: linear-gradient(90deg, ${STEP_COLOR.done} 0%, ${STEP_COLOR.active} 100%);
    }
    .sf-line.active {
        background: linear-gradient(90deg, ${STEP_COLOR.active} 0%, #e2e8f0 100%);
    }

    /* ── Re-cotización Tints ──────────────────────────────────── */
    .sf-track.requote .sf-dot.done {
        background: #f97316;
        border-color: #f97316;
    }
    .sf-track.requote .sf-dot.active {
        background: #ea580c;
        border-color: #ea580c;
        animation: sf-pulse-requote 1.6s infinite;
    }
    @keyframes sf-pulse-requote {
        0%   { box-shadow: 0 0 0 0 rgba(234, 88, 12, 0.4); }
        70%  { box-shadow: 0 0 0 7px rgba(234, 88, 12, 0); }
        100% { box-shadow: 0 0 0 0 rgba(234, 88, 12, 0); }
    }
`;

/* ─── STEPPER TOOLTIP (portal) ───────────────────────────────── */

export const stepperTooltipCSS = () => css`
    position: fixed;
    z-index: 9999;
    transform: translate(-50%, -100%);
    background: #0f172a;
    color: #ffffff;
    font-family: ${FONT};
    font-size: 0.72rem;
    font-weight: 500;
    line-height: 1.3;
    padding: 6px 10px;
    border-radius: 6px;
    max-width: 240px;
    pointer-events: none;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.25);
    white-space: normal;
    text-align: center;

    &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -4px;
        transform: translateX(-50%) rotate(45deg);
        width: 8px;
        height: 8px;
        background: #0f172a;
    }
`;

/* ─── VENDOR FILTER CHIPS ───────────────────────────────────── */

export const vendorFilterCSS = () => css`
    display: flex;
    align-items: center;
    gap: 0.45rem;
    flex-wrap: wrap;
    margin: 0 0 0.85rem;

    .vf-label {
        font-size: 0.75rem;
        font-weight: 600;
        color: #64748b;
        display: flex;
        align-items: center;
        gap: 5px;
        white-space: nowrap;
        margin-right: 0.2rem;
        flex-shrink: 0;
    }

    .vf-chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 10px;
        border-radius: 999px;
        border: 1px solid #e2e8f0;
        background: #ffffff;
        color: #475569;
        font-size: 0.72rem;
        font-weight: 500;
        cursor: pointer;
        transition:
            background 0.15s ease,
            border-color 0.15s ease,
            color 0.15s ease,
            transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
        font-family: ${FONT};
        white-space: nowrap;
    }
    .vf-chip:hover {
        border-color: #204B7B;
        color: #204B7B;
        background: #f0f4fa;
    }
    .vf-chip:active { transform: scale(0.95); }

    @media (max-width: 768px) {
        flex-wrap: nowrap;
        align-items: center;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x proximity;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        padding: 0.2rem 1rem 0.5rem;
        margin: 0 -1rem 0.6rem;
        gap: 0.45rem;
        mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        -webkit-mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }

        .vf-chip {
            flex: 0 0 auto;
            scroll-snap-align: start;
        }
        .vf-chip.active { transform: scale(1.04); }
    }
    .vf-chip.active {
        background: #204B7B;
        border-color: #204B7B;
        color: #ffffff;
        font-weight: 600;
    }

    .vf-avatar {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #cbd5e1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.55rem;
        font-weight: 700;
        color: #475569;
        flex-shrink: 0;
    }
    .vf-chip.active .vf-avatar {
        background: rgba(255,255,255,0.25);
        color: #ffffff;
    }

    /* Badge de fuente: punto de color pequeño */
    .vf-source-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        flex-shrink: 0;
    }
    .vf-source-dot.trim { background: #f59e0b; }
    .vf-source-dot.pei  { background: #32B8DF; }
`;

/* ─── CALIFICADAS TOGGLE ──────────────────────────────────────── */

export const calificadasToggleCSS = (active) => css`
    appearance: none;
    border: 1px solid ${active ? '#34d399' : '#cbd5e1'};
    background: ${active ? 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)' : '#ffffff'};
    color: ${active ? '#047857' : '#475569'};
    font-family: ${FONT};
    font-size: 0.78rem;
    font-weight: 700;
    padding: 0.45rem 0.85rem;
    border-radius: 999px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    margin: 0.3rem 0 0.6rem;
    transition: background 0.18s, border-color 0.18s, transform 0.06s, box-shadow 0.18s;
    box-shadow: ${active ? '0 2px 8px rgba(4, 120, 87, 0.18)' : '0 1px 2px rgba(15, 23, 42, 0.06)'};

    i { font-size: 0.85rem; color: ${active ? '#10b981' : '#94a3b8'}; }

    .ct-badge {
        font-size: 0.6rem;
        font-weight: 800;
        letter-spacing: 0.06em;
        padding: 2px 7px;
        border-radius: 6px;
        background: ${active ? '#047857' : '#e2e8f0'};
        color: ${active ? '#ecfdf5' : '#475569'};
    }

    &:hover {
        background: ${active ? '#d1fae5' : '#f8fafc'};
        border-color: ${active ? '#10b981' : '#94a3b8'};
    }
    &:active { transform: translateY(1px); }
`;

/* ─── ASSIGN BUTTON & POPOVER ─────────────────────────────────── */

export const assignButtonCSS = (isAssigned) => css`
    appearance: none;
    border: 1px solid ${isAssigned ? '#bae6fd' : '#86efac'};
    background: ${isAssigned ? '#f0f9ff' : '#f0fdf4'};
    color: ${isAssigned ? '#0369a1' : '#166534'};
    font-family: ${FONT};
    font-size: 0.74rem;
    font-weight: 700;
    padding: 0.4rem 0.65rem;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    line-height: 1;
    white-space: nowrap;
    transition: background 0.15s, border-color 0.15s, transform 0.05s;

    i { font-size: 0.78rem; width: 0.78rem; text-align: center; }

    &:hover:not(:disabled) {
        background: ${isAssigned ? '#e0f2fe' : '#dcfce7'};
        border-color: ${isAssigned ? '#7dd3fc' : '#4ade80'};
    }
    &:active:not(:disabled) {
        transform: translateY(1px);
    }
    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

export const assignPopoverCSS = () => css`
    font-family: ${FONT};
    min-width: 260px;
    max-width: 320px;

    .ap-title {
        font-size: 0.78rem;
        font-weight: 700;
        color: #0f172a;
        padding: 0 0.25rem 0.5rem;
        border-bottom: 1px solid #e2e8f0;
        margin-bottom: 0.4rem;
    }

    .ap-empty {
        padding: 0.6rem 0.25rem;
        font-size: 0.78rem;
        color: #64748b;
        text-align: center;
    }

    .ap-list {
        list-style: none;
        margin: 0;
        padding: 0;
        max-height: 280px;
        overflow-y: auto;
    }

    .ap-item {
        appearance: none;
        background: transparent;
        border: 1px solid transparent;
        width: 100%;
        text-align: left;
        padding: 0.5rem 0.55rem;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        gap: 2px;
        position: relative;
        font-family: ${FONT};
        transition: background 0.12s;

        &:hover:not(:disabled) {
            background: #f1f5f9;
        }
        &:disabled { cursor: default; }

        &.is-current {
            background: #ecfeff;
            border-color: #a5f3fc;
        }
    }
    .ap-item-name {
        font-size: 0.82rem;
        font-weight: 600;
        color: #0f172a;
    }
    .ap-item-email {
        font-size: 0.7rem;
        color: #64748b;
    }
    .ap-item-tag {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 0.6rem;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #0e7490;
        background: #cffafe;
        border: 1px solid #67e8f9;
        border-radius: 999px;
        padding: 1px 7px;
    }
    .ap-spinner {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 0.85rem;
        color: #64748b;
    }

    .ap-unassign {
        margin-top: 0.5rem;
        appearance: none;
        width: 100%;
        background: #fff1f2;
        color: #be123c;
        border: 1px solid #fecdd3;
        border-radius: 6px;
        padding: 0.45rem;
        font-size: 0.74rem;
        font-weight: 700;
        font-family: ${FONT};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.4rem;
        cursor: pointer;
        transition: background 0.12s;

        &:hover:not(:disabled) { background: #ffe4e6; }
        &:disabled { opacity: 0.6; cursor: not-allowed; }
    }
`;

/* ─── ADMIN ACTION BUTTONS ───────────────────────────────────── */

export const quoteAdminActionsCSS = () => css`
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;

    .qa-btn {
        appearance: none;
        border: 0;
        font-family: ${FONT};
        font-size: 0.75rem;
        font-weight: 600;
        padding: 0.35rem 0.8rem;
        border-radius: 10px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        line-height: 1;
        white-space: nowrap;
        transition: background 0.15s, transform 0.05s;
    }
    .qa-btn i { font-size: 0.78rem; width: 0.78rem; text-align: center; }
    .qa-btn:active:not(:disabled) { transform: translateY(1px); }
    .qa-btn:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
    .qa-btn-destructive {
        background: #ef4444;
        color: #ffffff;
    }
    .qa-btn-destructive:hover:not(:disabled) { background: #dc2626; }
    .qa-btn-neutral {
        background: #f1f5f9;
        color: #64748b;
    }
    .qa-btn-neutral:hover:not(:disabled) { background: #e2e8f0; }
`;

/* ─── REJECT MODAL ───────────────────────────────────────────── */

export const rejectModalCSS = () => css`
    font-family: ${FONT};

    &.rm-backdrop {
        position: fixed;
        inset: 0;
        z-index: 10000;
        background: rgba(15, 23, 42, 0.15);
        backdrop-filter: blur(2px);
    }

    &.rm-panel {
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 10001;
        width: min(440px, 100%);
        max-width: calc(100vw - 2rem);
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14), 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #e2e8f0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .rm-header {
        padding: 14px 16px;
        border-bottom: 1px solid #f1f5f9;
        background: #ffffff;
    }
    .rm-title {
        margin: 0;
        font-size: 1rem;
        font-weight: 700;
        color: #0f172a;
    }
    .rm-body {
        padding: 12px 14px 14px;
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
    }
    .rm-summary {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 10px;
        border-radius: 10px;
        background: rgba(50, 184, 223, 0.06);
        border: 1px solid rgba(50, 184, 223, 0.18);
    }
    .rm-summary-icon {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        background: #fef2f2;
        color: #dc2626;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 1rem;
    }
    .rm-summary-text {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
    }
    .rm-summary-name {
        font-size: 0.88rem;
        font-weight: 700;
        color: #0f172a;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .rm-summary-sub {
        font-size: 0.72rem;
        color: #64748b;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .rm-textarea {
        width: 100%;
        min-height: 112px;
        resize: vertical;
        border: 1px solid rgba(50, 184, 223, 0.28);
        border-radius: 10px;
        padding: 0.72rem 0.8rem;
        font-family: ${FONT};
        font-size: 0.85rem;
        color: #0f172a;
        outline: none;
        background: rgba(50, 184, 223, 0.04);
        transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
    }
    .rm-textarea:focus {
        border-color: #32b8df;
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(50, 184, 223, 0.12);
    }
    .rm-textarea:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
    .rm-actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }
    .rm-btn {
        appearance: none;
        border: 0;
        border-radius: 10px;
        padding: 0.45rem 0.85rem;
        font-family: ${FONT};
        font-size: 0.78rem;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.38rem;
        transition: background 0.15s, color 0.15s, transform 0.05s;
    }
    .rm-btn i { font-size: 0.78rem; width: 0.78rem; text-align: center; }
    .rm-btn:active:not(:disabled) { transform: translateY(1px); }
    .rm-btn:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
    .rm-btn-confirm {
        background: #ef4444;
        color: #ffffff;
    }
    .rm-btn-confirm:hover:not(:disabled) { background: #dc2626; }
    .rm-btn-cancel {
        background: transparent;
        color: #64748b;
    }
    .rm-btn-cancel:hover:not(:disabled) { background: #f1f5f9; }
`;

/* ─── SOURCE FILTER CHIPS (Todas / Pei / Trim) ───────────────── */

export const sourceFilterCSS = () => css`
    display: flex;
    gap: 0.45rem;
    flex-wrap: wrap;
    margin-bottom: 0.85rem;

    .src-chip {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 5px 16px;
        border-radius: 999px;
        border: 1px solid #e2e8f0;
        background: #ffffff;
        color: #475569;
        font-size: 0.8rem;
        font-weight: 600;
        font-family: ${FONT};
        cursor: pointer;
        transition:
            background 0.18s ease,
            border-color 0.18s ease,
            color 0.18s ease,
            box-shadow 0.18s ease,
            transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
        letter-spacing: 0.01em;
        white-space: nowrap;
    }
    .src-chip i { font-size: 0.72rem; }
    .src-chip:hover {
        border-color: #cbd5e1;
        background: #f8fafc;
    }
    .src-chip:active { transform: scale(0.95); }

    /* Todas activo */
    .src-chip.active {
        background: #0f172a;
        color: #ffffff;
        border-color: #0f172a;
        transform: scale(1.04);
    }

    /* Pei activo — gradiente azul */
    .src-chip.src-pei.active {
        background: linear-gradient(135deg, #204B7B 0%, #32B8DF 100%);
        color: #ffffff;
        border-color: #32B8DF;
        box-shadow: 0 2px 8px rgba(50, 184, 223, 0.28);
    }

    /* Trim activo — ámbar */
    .src-chip.src-trim.active {
        background: linear-gradient(135deg, #fde68a 0%, #fbbf24 100%);
        color: #78350f;
        border-color: #f59e0b;
        box-shadow: 0 2px 8px rgba(245, 158, 11, 0.25);
    }

    @media (max-width: 768px) {
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x proximity;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        padding: 0.2rem 1rem 0.5rem;
        margin: 0 -1rem 0.6rem;
        gap: 0.45rem;
        mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        -webkit-mask-image: linear-gradient(
            90deg,
            transparent 0,
            #000 16px,
            #000 calc(100% - 16px),
            transparent 100%
        );
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }

        .src-chip {
            flex: 0 0 auto;
            scroll-snap-align: start;
        }
    }
`;
